import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { BusinessThingsMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/business-things-metadata/business-things-metadata.component.abstract';
import { SharedBusinessMetadataV2Component } from '../shared-business-metadata-v2/shared-business-metadata-v2.component';

@Component({
  selector: 'app-business-things-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent, SharedBusinessMetadataV2Component],
  templateUrl: './business-things-metadata-v2.component.html',
})
export class BusinessThingsMetadataV2Component extends BusinessThingsMetadataComponentAbstract {}
